/* global process */
let base = window._env_.VUE_APP_ADMIN_HOST
export const queryMarketNg = params => {
  return axios.post(`${base}/market-ng/query`, params)
}
export const exportMarketNg = params => {
  return axios.post(`${base}/market-ng/export`, params)
}
export const queryMarketNgDetail = params => {
  return axios.post(`${base}/market-ng/query_detail`, params)
}



// WEBPACK FOOTER //
// ./src/views/market-ng/market-ng.api.js